import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {useAuth} from '../../../../../app/modules/auth'

export function SchoolLecturerMenu(): JSX.Element {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()
  const base = '/dphs/lecturer/'

  const menuItems = useMemo(
    () => [
      {permission: null, title: t('MENU.HOME'), to: `${base}home`},

      {permission: null, title: t('MENU.MY_COURSES'), to: `${base}my-courses`},

      {permission: null, title: t('MENU.PROFILE'), to: `${base}profile`},
      {permission: null, title: t('CHAT.CHAT'), to: `/chat/dphs-lec-chat-room`},
    ],
    [t]
  )

  const renderEntry = (item: any, index: any) => {
    if (item.permission && !hasPermission(item.permission)) return null

    if (item.children) {
      const visibleChildren = item.children.filter(
        (c: any) => !c.permission || hasPermission(c.permission)
      )
      if (!visibleChildren.length) return null

      return (
        <MenuInnerWithSub
          key={index}
          title={item.title}
          to={item.to}
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={false}
        >
          {visibleChildren.map((child: any, index: any) => (
            <MenuItem key={index} to={child.to} title={child.title} fontIcon={child.fontIcon} />
          ))}
        </MenuInnerWithSub>
      )
    }

    return <MenuItem key={item.to} title={item.title} to={item.to} />
  }

  return <>{menuItems.map(renderEntry)}</>
}
